import React, { Component } from "react";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import { Row } from "react-flexbox-grid";
import NumericInput from "react-numeric-input";

import InputLabel from "@material-ui/core/InputLabel";

class DelayForm extends Component {
  render() {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={3}>
          <br/>
          <Row center="xs">
            <InputLabel>Delay</InputLabel>
          </Row>
          <NumericInput
            mobile
            min={1}
            max={168}
            size={100}
            value={this.props.type === "openTill" ? this.props.openTillDelay : this.props.type === "replication" ? this.props.replicationDelay : 0}
            onChange={this.props.type === "openTill" ? this.props.handleOpenTillDelayChange : this.props.handleReplicationDelayChange}
            style={{
              width: "100%",
              wrap: {
                marginBottom: "10px"
              },
              input: {
                display: "block",
                fontWeight: 100,
                width: "100%",
                height: "35px"
              }
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}
export default DelayForm;



// WEBPACK FOOTER //
// ./src/components/Alerts/DelayForm.jsx